<sc-activate-account-error-container>
  Estamos experimentando problemas para activar tu cuenta, intentá nuevamente más tarde o <button id="open-help-form" class="sc-button sc-button--link" (click)="openHelpForm()">contactate con nosotros</button>
</sc-activate-account-error-container>